const translations = {
  title: "Global Platform",
  tools: {
    datasets: "Datasets",
  },
};

export default translations;
